var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChangeColorRectangular = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 32",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Curated",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Visual-Design---Infotainment",
  transform: "translate(-264.000000, -457.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(16.000000, 157.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-46"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-36",
  transform: "translate(16.000000, 291.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M235,9 L277,9 C278.656854,9 280,10.3431458 280,12 L280,38 C280,39.6568542 278.656854,41 277,41 L235,41 C233.343146,41 232,39.6568542 232,38 L232,12 C232,10.3431458 233.343146,9 235,9 Z",
  id: "Combined-Shape"
})))))))));
export { SvgChangeColorRectangular as ReactComponent };
export default __webpack_public_path__ + "static/media/changeColorRectangular.a35d1a00.svg";